import React, {Component, Fragment} from 'react';
import { Row, Col, Card } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";

import requestApi from "../services/requestApi.service";
import {
    getSessionValue,
    parseJSON,
    randstr,
    openNewTab
} from "./Appcommon";
import CratioTooltip from "./CratioTooltip";
import TotalCalls from "../assets/utils/images/Total_calls.png";
import ConnectedCalls from "../assets/utils/images/Connected_Calls.png";
import IncomingCalls from "../assets/utils/images/Incoming_Calls.png";
import OutgoingCalls from "../assets/utils/images/Outgoing_Calls.png";
import NotConnectedCalls from "../assets/utils/images/not_connected_calls.png";
import MissedCalls from "../assets/utils/images/Missed_Calls.png";
import RejectedCalls from "../assets/utils/images/Rejected_Call.png";
import UniqueCalls from "../assets/utils/images/Unique_Contacts.png";
import cx from "classnames";

export default class Summary extends Component{

    constructor(props) {
        super(props);

        this.state={
            summary : [],
            type : props.type,
            formname : props.type === "calls_analytics" ? process.env.REACT_APP_CALLLOG_FORMNAME : "",
            images : [TotalCalls, ConnectedCalls, NotConnectedCalls, UniqueCalls, IncomingCalls, OutgoingCalls, MissedCalls, RejectedCalls],
        }
    }

    async componentDidMount() {
        const {summaryData} = this.props;
        this.setState({summary: summaryData});
        
    }

    getCallCountData = async () => {
        const {dateFilter,filterTxt} = this.props;
        if(Object.keys(filterTxt).length > 0){
            let filterOption = [dateFilter,filterTxt];

            let neededFilters = [
                {'dateFilter' : true},
                {'users' : true},
                {'type' : true},
            ];
    
            let params = {
                "ENTITY": "MOBILE_PROCESS",
                "OPERATION": "GET_CALL_COUNT_DATA",
                "FORMNAME": this.state.formname,
                "isOtherApiReq" : true,
                "FILTEROPTION" : filterOption,
                "NEEDEDFILTERS" : neededFilters,
            };
    
            let responce = await requestApi.processServerRequest(params);
            if(responce.issuccess){
                let data = responce.data;
                this.setState({
                    summary : data,
                })
            }
        }
    }

    render(){

        let { summary, type, images} = this.state;
        let summaryList = [];
        let isWhastappAnalytics = type === "whatsapp_analytics" ;
        let isCallAnalytics = type === "calls_analytics";

        if(isWhastappAnalytics){
            if(summary && summary.length === 0 && getSessionValue('ANALYTICS_SUMMARY') !== ""){
                summary = parseJSON(getSessionValue('ANALYTICS_SUMMARY'));
            }
            summaryList = [
                {
                    label : 'Sent',
                    value : summary['sent'] || 0 ,
                    percentage : '',
                },
                {
                    label : 'Delivered',
                    value : summary['delivered'] || 0,
                    percentage : summary['deliveredPercentage'] || 0,
                },
                {
                    label : 'Read',
                    value : summary['read'] || 0,
                    percentage : summary['readPercentage'] || 0,
                },
                {
                    label : 'Replied',
                    value : summary['replied'] || 0,
                    percentage : summary['repliedPercentage'] || 0,
                },
                {
                    label : 'Un Deliverable',
                    value : summary['undeliverable'] || 0,
                    percentage : summary['undeliverablePercentage'] || 0,
                    infotitle : "This message was not sent by the Facebook API. (Click to more info)",
                    infourl : "https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/",
                },
                {
                    label : 'Failed',
                    value : summary['failed'] || 0,
                    percentage : summary['complainedPercentage'] || 0,
                    infotitle : "This message was not sent by the Facebook API. (Click to more info)",
                    infourl : "https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/",
                }
            ];
        }else if(isCallAnalytics){
            summaryList = summary;
        }

        return (
            <Fragment>
                <Row className={cx(`ml-1 mr-1 deliverylog__summary`, { 'call-log-charts' : isCallAnalytics})}>
                    {
                        summaryList.map((summary,index)=>{
                            let image = "";

                            if(isCallAnalytics){
                                image = images[index];
                            }

                            let infotitle = summary['infotitle'] ? summary['infotitle'] : "";
                            let infourl = summary['infourl'] ? summary['infourl'] : "";
                            //let lgVal = isCallAnalytics ? "3" : "2-5";

                            let lgVal = isCallAnalytics ? "3" : "2";

                            return (
                                <Col md="6" lg={lgVal} key={index}>
                                    <Card className="card-shadow-primary border mb-3 widget-chart widget-chart2 text-start">
                                        <div className="widget-chat-wrapper-outer">
                                            <div className="widget-chart-content">
                                                <span>
                                                    {image !== "" && <img src={image} className='summary-log-image'></img>}
                                                    <span className={cx("widget-subheading", {'summary-subheader-align' : type == "calls_analytics" })}>
                                                        {summary.label} &nbsp;
                                                        {
                                                            infotitle !== "" &&
                                                            <span className="widget-subheading-info">
                                                                <CratioTooltip
                                                                    title={infotitle}
                                                                    id={randstr('cam_' + index)}
                                                                    content={
                                                                        <>
                                                                            <FontAwesomeIcon icon={faCircleInfo} className='cursor-p' onClick={e => openNewTab(infourl)}/>
                                                                        </>
                                                                    }
                                                                />
                                                            </span>
                                                        }
                                                    </span>
                                                </span>
                                                <div className="widget-chart-flex">
                                                    <div className="widget-numbers mb-0 w-100">
                                                        <div className="widget-chart-flex">
                                                            <div className="fsize-4">
                                                                {summary.value}
                                                            </div>
                                                            <div className="ms-auto">
                                                            <div className={cx("widget-title ms-auto fw-normal font-size-lg text-muted", {'call-log-timing' : isCallAnalytics})}>
                                                                    {isWhastappAnalytics && <span className="text-success ps-2">{ summary.percentage !== '' ? summary.percentage.toFixed(0)+'%' : ''}</span>}

                                                                    {isCallAnalytics && <span className="text-success ps-2">{ summary.time !== '' ? summary.time : ''}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            );
                        })
                    }
                </Row>
            </Fragment>
        );
    }

}


